import React, { useEffect, useMemo, useState } from "react";
// import AdminImg from '../../Img/usrpict.PNG';
import { RiEditBoxFill, RiFileEditFill } from "react-icons/ri";
import AdminImg from "../../Img/viewer.png";
// import Viewer from '../../Img/viewer.png'
// import campraImg from "../../Img/LOGORepository.png"
import campraImg from "../../Img/logo.png";
import remove from "../../Img/delete.png";
import edit from "../../Img/edit.png";
import CategoryList from "./CategoryList";
// <<<<<<< HEAD
import back from "../../Img/new home.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "../Spinner";
import { toast } from "react-toastify";
import Viewer from "../../Img/viewer.png";
import myarticles from "../../Img/new article.png";
import { Button, Dropdown, Modal } from "react-bootstrap";
import TopNavBar from "../TopNavBar";
import SideBar from "../SideBar";
import { API_BASE_URL } from "../../utils/config";
// import { MdDeleteForever } from "react-icons/md";
import { MDBDataTable } from "mdbreact";
// import { FaImage, FaUserEdit } from "react-icons/fa";
import MdDeleteForever from "../../Img/delete.png";
import FaUserEdit from "../../Img/edit user.png";
import { IoEye } from "react-icons/io5";
import ret from "mammoth/mammoth.browser";
import AddWhiteListImage from "../../Img/create whitelist url.png";
import AddCategoryImage from "../../Img/add.png";
import ManageCategoryImage from "../../Img/manage category.png";
import SaveImage from "../../Img/save.png";
import UpdateImage from "../../Img/update.png";
import NewTopNavBar from "../NewTopNavBar";
const mammoth = require("mammoth/mammoth.browser");
// import mammoth from 'mammoth';
const cheerio = require("cheerio");
// =======
// import back from '../../Img/home_738822.png';
// >>>>>>> d8aaf382d53b54b6495407231a922f7960218c95

const WigetAdmin = () => {
  const navigate = useNavigate();
  const backBtn = () => {
    navigate("/searchLandingPage");
  };
  const [isChecked, setIsChecked] = useState(false);

  const [totalNoOfUsers, setTotalNoOfUsers] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5;
  const [apiResponse, setApiRespose] = useState([]);
  const [show, setShow] = useState(false);
  const [catagories, setCatagories] = useState([]);

  const [createUsersShow, setCreateUsersShow] = useState(false);
  const [createCategoryShow, setCreateCategoryShow] = useState(false);
  const [loader, setLoader] = useState(false);

  const [page, setPage] = useState(1);

  const [reload, setReload] = useState(false);
  const [allCategories, setALLCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [collaps, setCollaps] = useState(true);
  const [allUsers, setAllUsers] = useState([]);
  const [featureImage, setFeatureImage] = useState("");

  const [updatePostId, setUpdatePostId] = useState("");

  const [authors, setAuthors] = useState([]);
  const [editWhistlist, setEditWhiteList] = useState(false);
  const [editWhiteListId, setEditWhiteListId] = useState();
  const [parentCategory, setParentCategory] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [TenentAdmins, setTenentAdmins] = useState([]);
  const [allTenantAdmin, setAllTenantAdmin] = useState([]);
  const [prevSelectedId, setPrevSelectedIds] = useState(0);
  const [prevSelectUserName, setPrevSelectUserName] = useState("");
  const [createUsersFormData, setCreateUsersFormData] = useState({
    toggle_status: "",
    url: "",
    start_date: "",
    // toggle_status: '',
    end_date: "",
    slug: "",
    tenent: "",
    tenent_user_id: 0,
  });
  const [errors, setErrors] = useState({});

  let CurrentUserId = localStorage.getItem("current_user_Id");
  let bearerToken = localStorage.getItem("jwt_token");
  const rolles = localStorage.getItem("roles");
  //
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  // get parent Categories start

  const getTenentAdmins = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-user-api/v1/users`, config)
      .then((res) => {
        const filterTentAdmin = res.data.filter((res) => {
          if (res.user_roles == "editor") {
            return res;
          }
        });

        axios
          .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`)
          .then((response) => {
            console.log("apiresponse112=", response.data);
            console.log("apiresponse112filterTentAdmin=", filterTentAdmin);

            const tenentUserIds = response.data.map(
              (item) => item.tenent_user_id
            );

            const unSeletTenantAdmin = filterTentAdmin.filter(
              (item) => !tenentUserIds.includes(item.ID)
            );
            // setTenentAdmins(unSeletTenantAdmin);

            setTenentAdmins(filterTentAdmin);
            setAllTenantAdmin(unSeletTenantAdmin);

            // const bothTenantAdmin
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getTenentAdmins();
  }, [reload]);

  const getParentCategories = () => {
    axios
      .get(
        `${API_BASE_URL}/wp-json/custom-category/v1/get-all-categories`,
        config
      )
      .then((res) => {
        console.log("getAllCategories=", res.data);

        const filterData = res.data.filter((data) => data.parent == 0);
        console.log("filterData=", filterData);
        setParentCategory(filterData);
        setSelectedIds(filterData.map((item) => item.id));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  console.log("line11=", selectedIds);

  const handleCategoryClose = () => {
    setCreateCategoryShow(false);
    setSelectedIds(parentCategory.map((item) => item.id));
  };
  const handleShowCategory = () => {
    setCreateCategoryShow(true);
  };

  const handleCheckboxChange = (id) => {
    if (selectedIds?.includes(id)) {
      setSelectedIds(selectedIds.filter((itemId) => itemId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };
  const handleCreateCategory = () => {
    // e.preventDefault();
    if (selectedIds.length < 1) {
      toast.error("Please select at least one category.");
      return;
    } else {
      setCreateCategoryShow(false);
    }
  };
  // get parent categories end

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  const handleDelete = async (id) => {
    // setNewDelete(false)
    try {
      const confirmed = window.confirm(
        "Are you sure you want to delete this article?"
      );
      if (!confirmed) {
        return;
      }

      const apiEndpoint = `${API_BASE_URL}/wp-json/custom-api/v1/delete-data/${id}`;

      axios
        .delete(apiEndpoint, config)
        .then((response) => {
          toast.success("Whitelist Deleted Successfully");
          setReload(reload ? false : true);
        })
        .catch((error) => {
          console.error("Error deleting post:", error);
        });
    } catch (error) {
      console.error("Error deleting Enter Code data:", error);
    }
  };
  //
  const isUrlValid = (url) => {
    // const regex = new RegExp('^(https?:\\/\\/)?' + // protocol
    //     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    //     '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    //     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    //     '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    //     '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    const regex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return regex.test(url);
  };
  const isLowerCase = (str) => {
    const regex = /^[a-zA-Z]+$/;
    return regex.test(str);
  };
  //
  const handleChangeCreateUsers = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    console.log(`231 name= ${name}. value= ${value}`);
    // if (/^[^A-Z]*$/.test(value)) {
    // alert(value)
    setCreateUsersFormData({
      ...createUsersFormData,
      [name]: value,
    });
    // }

    // setCreateUsersFormData({
    //     ...createUsersFormData,
    //     [name]: value,
    // });
  };
  const handleCreateWhiteList = (e) => {
    // alert(isUrlValid(createUsersFormData.url))
    // return;

    e.preventDefault();
    // alert(editId)
    // setIsChecked(false)
    const newErrors = {};

    // let startDate = new Date(createUsersFormData.start_date);
    // let endDate = new Date(createUsersFormData.end_date);

    // // console.log("197=", startDate >= endDate);
    // if (startDate >= endDate) {
    //     newErrors.end_date = 'start date must be greater-than start date';

    // }
    // if (selectedIds.length < 1) {
    //     toast.error('Please select at least one category.');
    //     return;
    // }

    if (!isUrlValid(createUsersFormData.url)) {
      newErrors.url = "Enter valid url";
    }
    if (!createUsersFormData.url) {
      newErrors.url = "Url name is required";
      // return
    }
    if (
      !isLowerCase(createUsersFormData.slug) &&
      createUsersFormData.slug.length > 0
    ) {
      newErrors.slug = "Enter valid slug";
    }

    // if (!createUsersFormData.password) {
    //   newErrors.password = 'Password is required';
    // }
    // if (!createUsersFormData.start_date) {
    //     newErrors.start_date = 'Start date is required';
    // }
    // if (!createUsersFormData.end_date) {
    //     newErrors.end_date = 'End date is required';
    // }
    // if (!createUsersFormData.toggle_status) {
    //     newErrors.toggle_status = 'Toggle Status is required';
    // }

    setErrors(newErrors);

    if (
      createUsersFormData.url[createUsersFormData.url.length - 1] != "/" &&
      Object.keys(newErrors).length === 0
    ) {
      createUsersFormData.url = createUsersFormData.url + "/";
    }
    console.log("173=", createUsersFormData.url);
    // return

    if (Object.keys(newErrors).length === 0) {
      const userData = {
        url: createUsersFormData.url,
        start_date: createUsersFormData.start_date,
        end_date: createUsersFormData.end_date,
        toggle_status: isChecked,
        slug: createUsersFormData.slug,
        category: selectedIds,
        tenent: createUsersFormData.tenent,
        tenent_user_id: createUsersFormData.tenent_user_id,
      };

      // userData.password = password
      console.log("userData=", userData);
      // return;

      axios
        .post(
          `${API_BASE_URL}/wp-json/custom-api/v1/store-data`,
          userData,
          config
        )
        .then((response) => {
          if (response.data.success == false) {
            toast.error("Whitelist URL already exists");
            // newErrors.url = 'Whitelist URL already exists';
          } else {
            toast.success("Whitelist Created Successfully");
            setCreateUsersShow(false);
            setCreateUsersFormData({
              url: "",
              start_date: "",
              end_date: "",
              toggle_status: "",
              tenent: "",
            });
            setSelectedIds(parentCategory.map((item) => item.id));

            setReload(reload ? false : true);
          }
        })
        .catch((error) => {
          toast.error(error.response.data.message);
          console.error("Error creating user:", error);
        });
    }
  };

  const handleEditWhiteList = (e, id) => {
    e.preventDefault();
    // alert(editId)
    // if (selectedIds.length < 1) {
    //     toast.error('Please select at least one category.');
    //     return;
    // }
    const newErrors = {};

    // let startDate = new Date(createUsersFormData.start_date);
    // let endDate = new Date(createUsersFormData.end_date);

    // // console.log("197=", startDate >= endDate);
    // if (startDate >= endDate) {
    //     newErrors.end_date = 'start date must be greater-than start date';

    // }

    if (!isUrlValid(createUsersFormData.url)) {
      newErrors.url = "Enter valid url";
    }
    if (!createUsersFormData.url) {
      newErrors.url = "Url name is required";
      // return
    }
    if (
      !isLowerCase(createUsersFormData.slug) &&
      createUsersFormData.slug.length > 0
    ) {
      newErrors.slug = "Enter valid slug";
    }

    // if (!createUsersFormData.password) {
    //   newErrors.password = 'Password is required';
    // }
    // if (!createUsersFormData.start_date) {
    //     newErrors.start_date = 'Start date is required';
    // }
    // if (!createUsersFormData.end_date) {
    //     newErrors.end_date = 'End date is required';
    // }
    // if (!createUsersFormData.toggle_status) {
    //     newErrors.toggle_status = 'Toggle Status is required';
    // }

    setErrors(newErrors);

    if (
      createUsersFormData.url[createUsersFormData.url.length - 1] != "/" &&
      Object.keys(newErrors).length === 0
    ) {
      createUsersFormData.url = createUsersFormData.url + "/";
    }

    if (Object.keys(newErrors).length === 0) {
      const userData = {
        url: createUsersFormData.url,
        start_date: createUsersFormData.start_date,
        end_date: createUsersFormData.end_date,
        toggle_status: isChecked,
        slug: createUsersFormData.slug,
        category: selectedIds,
        tenent: createUsersFormData.tenent,
        tenent_user_id: createUsersFormData.tenent_user_id,
      };

      // userData.password = password

      console.log("line401edit=", userData);
      console.log("line401edit=", prevSelectedId);

      // return;

      axios
        .put(
          `${API_BASE_URL}/wp-json/custom-api/v1/get-data/${id}`,
          userData,
          config
        )
        .then((response) => {
          if (response.data.success == false) {
            toast.error("Whitelist URL already exists");
          } else {
            toast.success("Whitelist Updated Successfully");
            setCreateUsersShow(false);

            // transfer user meta value start
            if (prevSelectedId != userData.tenent_user_id) {
              axios
                .post(
                  `${API_BASE_URL}/wp-json/oracle/v1/transfer_user_meta`,
                  {
                    from_user_id: prevSelectedId,
                    to_user_id: userData.tenent_user_id,
                    url: userData.url,
                  },
                  config
                )
                .then((response) => {
                  // alert(response.data.message);
                })
                .catch((error) => {
                  console.error(error);
                  // alert('Error transferring user meta data');
                });
            }
            // transfer user meta value end

            setCreateUsersFormData({
              url: "",
              start_date: "",
              end_date: "",
              toggle_status: "",
              tenent: "",
            });
            setReload(reload ? false : true);
            setSelectedIds(parentCategory.map((item) => item.id));
          }
        })
        .catch((error) => {
          toast.error(error.response.data.message);
          console.error("Error creating user:", error);
        });
    }
  };

  const handleClose = () => {
    setShow(false);
    setCreateUsersShow(false);
    setCreateUsersFormData({
      url: "",
      start_date: "",
      end_date: "",
      toggle_status: "",
      tenent: "",
    });
    setErrors("");
  };
  const createusersHandleChange = () => {
    setPrevSelectUserName("");
    setEditWhiteList(false);
    setCreateUsersShow(true);
    setIsChecked(false);
    // formData.username = ""
    // formData.email = "";
  };
  //

  useEffect(() => {
    if (!bearerToken) {
      navigate("/");
    } else {
      let sessionId = sessionStorage.getItem("sessionId");
      if (!sessionId) {
        let sessionId = Math.floor(Math.random() * 100000);
        sessionStorage.setItem("sessionId", sessionId);
        navigate("/all-articles");
      } else {
        const fetchCategories = async () => {
          // setNewDelete(true)
          setLoading(true);
          try {
            const response = await axios.get(
              `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`,
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                  "Content-Type": "application/json",
                },
              }
            );
            const categoryData = response.data.map((category) => ({
              id: category.id,
              name: category.name,
              parent: category.parent,
            }));
            setALLCategories(categoryData);
          } catch (error) {
            console.error("Error fetching categories:", error);
          } finally {
            setLoading(false);
          }

          // get all users

          try {
            const response = await axios.get(
              `${API_BASE_URL}/wp-json/custom-user-api/v1/users/`,
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                  "Content-Type": "application/json",
                },
              }
            );
            // const categoryData = response.data.map((category) => ({
            //   id: category.id,
            //   name: category.name,
            // }));
            setAllUsers(response.data);
            console.log("allusers=", response.data);
          } catch (error) {
            console.error("Error fetching categories:", error);
          } finally {
            setLoading(false);
          }
          // get all users
        };

        fetchCategories();

        //
        let ApiEndPoint = `${API_BASE_URL}/wp-json/custom-api/v1/get-data`;

        axios
          .get(`${ApiEndPoint}`, {
            // axios.get(`${API_BASE_URL}/wp-json/wp/v2/posts?per_page=${perPage}&page=${page}`, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            setTotalNoOfUsers(response.data.length);

            setCatagories(response.data);
            setApiRespose(response.data);
            setLoader(true);
          });
      }

      const getAllAuthors = () => {
        axios
          .get(`${API_BASE_URL}/wp-json/custom-user-api/v1/users/`, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            // Filter out users with the role "subscriber"
            // console.log("235=", res)
            const filteredUsers = res.data.filter(
              (user) => !user.user_roles.includes("subscriber")
            );
            // console.log("filteredUsers", filteredUsers);
            // setUsers(filteredUsers);
            setAuthors(filteredUsers);
          })
          .catch((err) => {
            console.log(err);
          });
      };
      getAllAuthors();
    }

    getParentCategories();
  }, [reload]);

  //

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = apiResponse.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  //

  const handleEdit = (data) => {
    // localStorage.setItem('postId', postId)
    // navigate("/edit-post");
    // setTenentAdmins
    setPrevSelectUserName(data.tenent_users);
    setPrevSelectedIds(data.tenent_user_id);
    console.log("line560=", data);
    setEditWhiteList(true);
    setCreateUsersShow(true);
    setEditWhiteListId(data.id);
    setCreateUsersFormData({
      url: data.url,
      toggle_status: data.toggle_status,
      slug: data.slug,
      tenent: data.tenent,
      tenent_user_id: data.tenent_user_id,
    });
    setIsChecked(data.toggle_status);
    setSelectedIds(data.categoryId);
  };
  const handleSubmitCreateUsers = (e) => {
    if (editWhistlist) {
      handleEditWhiteList(e, editWhiteListId);
    } else {
      handleCreateWhiteList(e);
    }
  };

  const changeCollapsState = () => {
    if (collaps) {
      setCollaps(false);
    } else {
      setCollaps(true);
    }
  };

  ////////////////DataTable data/////////////////////////////////////

  let articleData = apiResponse.map((e) => {
    console.log("392e=", e);
    // let status = ""
    // if (e.toggle_status) {
    //     status = "Active"
    // } else {
    //     status = "InActive"
    // }

    console.log("tanentAdmins=", TenentAdmins);

    const tenentUsers = TenentAdmins.filter((res) => {
      if (res.ID == e.tenent_user_id) {
        return res;
      }
    });
    console.log("tenentUsers=", tenentUsers);

    let obj = {
      id: e.id,
      url: e.url,
      // start_date: e.start_date,
      // end_date: e.end_date,
      toggle_status: e.toggle_status,
      username: e.username,
      slug: e.slug,
      tenent: e.tenent,
      // tenent: `${e.tenent}\n${e.url}`,
      categoryId: e.category,
      tenent_user_id: e.tenent_user_id,
      tenent_users: tenentUsers.length > 0 ? tenentUsers[0].user_login : "",
    };

    console.log("author=", obj);

    return obj;
  });

  // useEffect(() => {
  //     const toggleStatus = createUsersFormData.toggle_status; // Example value, replace with actual logic to fetch toggle status
  //     setIsChecked(toggleStatus);
  // }, []);

  const data = useMemo(
    () => ({
      columns: [
        {
          label: "Tenant",
          field: "tenent_with_url",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        // {
        //     label: 'StartDate',
        //     field: 'start_date',
        //     width: 300,
        //     sort: '',
        //     fixedHeader: true
        // },
        // {
        //     label: 'EndDate',
        //     field: 'end_date',
        //     width: 300,
        //     sort: '',
        //     fixedHeader: true
        // },
        {
          label: "Tenant Admin",
          field: "tenent_users",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Status",
          field: "status",
          width: 50,
          sort: "disabled",
          fixedHeader: true,
        },
        {
          label: "Action",
          field: "delete",
          sort: "disabled",
          width: 100,
          fixed: true,
        },
      ],

      rows: articleData.map((e) => {
        function toCapitalize(text) {
          return text?.charAt(0).toUpperCase() + text?.slice(1).toLowerCase();
        }
        let current = e;
        console.log("current=", current);
        return Object.assign(e, {
          tenent_with_url: (
            <div>
              <div>{e.tenent}</div>
              <div>{e.url}</div>
            </div>
          ),
          status: (
            <div>
              {e.toggle_status ? (
                <div className="text-success fw-semibold">Active</div>
              ) : (
                <div className="text-danger fw-semibold">Inactive</div>
              )}
            </div>
          ),
          delete: (
            <div className="d-flex justify-content-center">
              {/* <FaUserEdit
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                onClick={() => handleEdit(current)}
                role="button"
                size={25}
                color="#0d6efd"
              />{" "} */}
              <img
                className="mx-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Edit"
                role="button"
                onClick={() => handleEdit(current)}
                src={FaUserEdit}
                alt=""
              />
              {/* <MdDeleteForever
                data-toggle="tooltip"
                data-placement="bottom"
                title="Delete"
                onClick={() => handleDelete(current.id)}
                size={25}
                color="#0d6efd"
                role="button"
              /> */}
              <img
                className=""
                data-toggle="tooltip"
                data-placement="bottom"
                title="Delete"
                role="button"
                onClick={() => handleDelete(current.id)}
                src={MdDeleteForever}
                alt=""
              />
              {/* <IoEye data-toggle="tooltip" data-placement="bottom" title="View" color='#0d6efd' role='button' size={25} onClick={() => gotToArticlePage(current.id)} /> */}
              {/* <FaImage data-toggle="tooltip" data-placement="bottom" title="Featured Image" color='#0d6efd' role='button' size={25} onClick={() => handleEditFeaturedImage(current.id)} /> */}
            </div>
          ),
          checkbox: (
            <label className="toggle-switch">
              <input
                type="checkbox"
              // checked={btn.isChecked}
              // onChange={() => handleToggle(index)}
              />
              <span className="slider round"></span>
            </label>
          ),
        });
      }),
    }),
    [articleData, reload]
  );

  ////////////////DataTable data end/////////////////////////////////

  useEffect(() => {
    let thead = document.querySelectorAll("th");
    console.log("432thead=", thead);
    // let tbody = document.querySelectorAll('td')
    for (let i = 0; i < thead.length; i++) {
      if (rolles == "administrator") {
        if (i == 0) {
          // thead[i].style.cssText = `width:40%;  `
          thead[i].style.cssText = `word-wrap: break-word; width:40%;`;
        }
        if (i === 1) {
          thead[i].style.cssText = `width:20%; `;
        }
      } else {
        if (i === 0) {
          thead[i].style.cssText = `width:35%; `;
        }
      }
    }
  }, [articleData, reload, apiResponse]);

  return (
    <div>
      <div className="row g-0">
        <div
          style={{ minHeight: "90vh" }}
          className={
            collaps ? "column right-column  col" : "column right-column  col "
          }
        >
          {/* <!-- Content for the right column goes here --> */}
          <div className="w-100">
            <NewTopNavBar />
          </div>

          {/* add/edit categorymodal */}
          <Modal
            show={createCategoryShow}
            onHide={handleCategoryClose}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {/* {editWhistlist ? "Update" : "Add"} */}
                Manage Categories
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row g-0 w-100 ">
                {parentCategory
                  ? parentCategory.map((item) => (
                    <div key={item.id}>
                      <input
                        type="checkbox"
                        id={item.slug}
                        value={item.id}
                        checked={selectedIds?.includes(item?.id)}
                        onChange={() => handleCheckboxChange(item.id)}
                      />
                      <label htmlFor={item.slug}>{item.name}</label>
                    </div>
                  ))
                  : ""}
              </div>
            </Modal.Body>
            <Modal.Footer>
              {/* <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button> */}
              {/* <Button variant="primary" onClick={handleCreateCategory}>
                                {editWhistlist ? "Update" : "Add"}
                            </Button> */}
              {editWhistlist ? (
                <img
                  onClick={handleCreateCategory}
                  className="commonLogo"
                  // width={40}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Update"
                  role="button"
                  src={UpdateImage}
                  alt="Update"
                />
              ) : (
                <img
                  className="commonLogo"
                  onClick={handleCreateCategory}
                  width={50}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Add"
                  role="button"
                  src={UpdateImage}
                  alt="Add"
                />
              )}
            </Modal.Footer>
          </Modal>

          {/* add/edit categorymodal */}

          {/* Create WhiteList Modal Start */}

          <Modal show={createUsersShow} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>
                {editWhistlist ? "Update" : "Create"} Whitelist
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row g-0 w-100 ">
                {/* <form > */}
                <div className="form-group">
                  <label for="exampleInputEmail1">Url Name:</label>
                  <input
                    className="form-control"
                    type="text"
                    name="url"
                    value={createUsersFormData.url}
                    placeholder="Enter Url Name"
                    onChange={handleChangeCreateUsers}
                  />
                  {errors.url && <p className="error">{errors.url}</p>}
                </div>
                <div className="form-group">
                  <label for="exampleInputEmail1">Tenant Name:</label>
                  <input
                    className="form-control"
                    type="text"
                    name="tenent"
                    value={createUsersFormData.tenent}
                    placeholder="Enter Tenant  Name"
                    onChange={handleChangeCreateUsers}
                  />
                  {errors.slug && <p className="error">{errors.slug}</p>}
                </div>

                <div className="form-group">
                  <label>Tenant Admin:{prevSelectUserName}</label>
                  <select
                    className="w-100"
                    id="categorySelect"
                    name="tenent_user_id"
                    // value="test"
                    value={createUsersFormData.tenent_user_id}
                    onChange={handleChangeCreateUsers}
                  >
                    <option value="">Select Tenant Admin</option>
                    {allTenantAdmin.map((role) => (
                      <option key={role.tenent_user_id} value={role.ID}>
                        {role.user_login}
                      </option>
                    ))}
                  </select>
                  {errors.selectedRole && (
                    <p className="error">{errors.selectedRole}</p>
                  )}
                </div>
                <div>
                  {/* <button className='btn btn-primary' onClick={handleShowCategory}>  {editWhistlist ? "Add/Edit" : "Add"} categories</button> */}
                  <img
                    className="mt-2 commonLogo"
                    onClick={handleShowCategory}
                    // width={45}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Manage Category"
                    role="button"
                    src={ManageCategoryImage}
                    alt="Manage Category"
                  />
                </div>
                <label htmlFor="status" className="mt-2 mb-1">
                  Status
                </label>
                <div className="">
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      // checked={createUsersFormData.toggle_status?cre}
                      checked={isChecked}
                      onChange={handleToggle}
                    />
                    <span className="slider round"></span>
                  </label>
                  <label htmlFor="">
                    {isChecked ? (
                      <div className="text-success fw-bold">Active</div>
                    ) : (
                      <div className="text-danger fw-bold">InActive</div>
                    )}
                  </label>
                </div>

                {/* </form> */}
              </div>
            </Modal.Body>
            <Modal.Footer>
              {/* <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button> */}
              {/* <Button variant="primary" onClick={handleSubmitCreateUsers}>
                                {editWhistlist ? "Update" : "Create"}
                            </Button> */}
              {!editWhistlist ? (
                <img
                  className="commonLogo"
                  onClick={handleSubmitCreateUsers}
                  // width={40}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Create"
                  role="button"
                  src={UpdateImage}
                  alt="Create"
                />
              ) : (
                <img
                  className="commonLogo"
                  onClick={handleSubmitCreateUsers}
                  // width={40}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Update"
                  role="button"
                  src={UpdateImage}
                  alt="Update"
                />
              )}
            </Modal.Footer>
          </Modal>

          {/* Create Whitelist modal end */}

          {loader ? (
            <div
              className="w-100"
              style={{ minHeight: "80vh", padding: "20px 30px 20px 50px" }}
            >
              <div
                style={{
                  // background: '#ececec',
                  boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                  // margin: '20px 30px'
                }}
                className="row w-100"
              >
                <div className="all-articles col" style={{ minHeight: "66vh" }}>
                  <div className="d-flex justify-content-between">
                    <h2 className="pt-3 mb-0 fw-bold">My Whitelist</h2>

                    <div>
                      {/* <button onClick={createusersHandleChange} className='mb-0 me-1 btn btn-primary ' style={{ width: '208px' }}> + Create Whielist</button> */}

                      <img
                        className="m-2 commonLogo"
                        onClick={createusersHandleChange}
                        // width={40}
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Create Whitelist"
                        role="button"
                        src={AddWhiteListImage}
                        alt="Create Whielist"
                      />
                    </div>
                  </div>
                  <div>
                    {
                      rolles == "administrator" ? (
                        <MDBDataTable
                          noRecordsFoundLabel={`${articleData.length < 1
                            ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button'
                            : "No matching records found"
                            }`}
                          fixed
                          sortable
                          bordered
                          autoWidth={false}
                          data={data}
                          entries={5}
                          entriesOptions={[5, 10, 15, 20]}
                          noBottomColumns
                          disableRetreatAfterSorting={true}
                        />
                      ) : (
                        ""
                      )
                      // <MDBDataTable noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`} fixed sortable bordered autoWidth={false} data={data2} entries={5} entriesOptions={[5, 10, 15, 20]} noBottomColumns disableRetreatAfterSorting={true} />
                    }
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center w-100 my-5">
              <Spinner />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WigetAdmin;
